import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Form, Button, Header, Grid, Loader,
  CheckboxProps, Dimmer, Checkbox
} from 'semantic-ui-react';
import { toast } from 'react-toastify';
import axiosInstance from '../../helpers/axiosInstance';
import AdminSidebar from '../Common/SharedComponents/AdminSidebar';
import UserInfo from '../Common/SharedComponents/UserInfo';
import AppContext, { token_config } from '../../AppContext';
import SwitchTheme from '../Common/SharedComponents/SwitchTheme';

export const NotificationForm: React.FC = () => {
  const navigate = useNavigate();
  const { userInfo } = useContext(AppContext);

  useEffect(() => {
    if (userInfo !== undefined) {
      const privileges: string[] = userInfo ? userInfo.Privileges.split(',') : [];
      if (!privileges.includes(token_config.MANAGE_USER_NOTIFICATIONS)) {
        navigate('/');
      }
    }
  }, [userInfo, navigate]);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [notificationsAllowed, setNotificationsAllowed] = useState<boolean>();

  useEffect(() => {
    document.title = 'Notifications - Adjure';
    fetchData();
  }, [userInfo]);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      await axiosInstance.get(`/AdminSetting/GetUserNotification`).then(({ data, status }) => {
        if (status === 200) {
          setNotificationsAllowed(data);
        }
        setIsLoading(false);
      })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
        });
    } catch (error: any) {
      setIsLoading(false);
      console.log(error);
    }
  }

  const handleCheckboxChange = (event: React.FormEvent<HTMLInputElement>, data: CheckboxProps, field: string) => {
    setNotificationsAllowed(data.checked);
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    // handle form submission 
    axiosInstance.post(`/AdminSetting/UpdateUserNotification/${notificationsAllowed}`, {}).then(({ data, status, statusText }) => {
      if (status === 200) {
        toast.success('Notifications updated successfully');
        navigate('/notifications');
      }
      setIsLoading(false);
    });
  };

  return (
    <section className="section" style={{
      minHeight: '100vh'
    }}>
      <div className="section__head">
        <div className="section__head-content">
          <Header as="h1">Notifications</Header>
        </div>
        <div className="section__actions">
          <UserInfo />
          <SwitchTheme />
        </div>
      </div>
      <div className='section__body'>
        {
          <Dimmer.Dimmable as="div" dimmed={isLoading}>
            <Dimmer active={isLoading} inverted={true}>
              <Loader>Loading</Loader>
            </Dimmer>
            <Grid padded>
              <Grid.Row>
                <Grid.Column mobile={16} tablet={3} computer={3}>
                  <AdminSidebar />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={8} computer={8}>
                  <Form className='form-custom'>
                    <Form.Field>
                      <Checkbox
                        label='Subscribe to Email Updates'
                        value={'true'}
                        checked={notificationsAllowed === true}
                        onChange={(e, data) => handleCheckboxChange(e, data, 'notificationsAllowed')}
                        style={{
                          margin: '1rem 1rem 0rem 1rem',
                          fontSize: '1.6rem'
                        }}
                      />
                    </Form.Field>
                    <Grid>
                      <Grid.Column>
                        <Button type="submit" onClick={handleSubmit} className='violet right floated button' style={{ padding: '1.1rem 2.1rem', borderRadius: '0rem' }}>
                          Save
                        </Button> {' '}
                        <Button type="button" className='second right floated button' style={{ padding: '1.1rem 2.1rem', borderRadius: '0rem', color: 'white' }} onClick={() => navigate('/notifications')}>
                          Cancel
                        </Button>
                      </Grid.Column>
                    </Grid>
                  </Form>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <br />
          </Dimmer.Dimmable>
        }
      </div>
    </section>
  );
}

export default NotificationForm;